/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Gym_HomeInputs */

const en_features_gym_home = /** @type {(inputs: Features_Gym_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I train at home`)
};

const pl_features_gym_home = /** @type {(inputs: Features_Gym_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trenuję w domu`)
};

/**
* | output |
* | --- |
* | "I train at home" |
*
* @param {Features_Gym_HomeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_gym_home = /** @type {((inputs?: Features_Gym_HomeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Gym_HomeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_gym_home(inputs)
	return en_features_gym_home(inputs)
});